import React, { useRef, useState } from 'react';

import { AnimatePresence } from 'framer-motion';
import { useTranslation } from 'react-i18next';

import { ReactComponent as ControlsIcon } from '@pkg/assets/icons/controls-icon.svg';
import { Drawer } from '@pkg/components';
import { useMediaQuery } from '@pkg/providers';

import { Popover, Settings } from './components';

import { OptionsButton, StyledGroupHeaderOptions } from './styles';

interface GroupHeaderOptionsProps {
    showUnfollowButton: boolean;
}

export function GroupHeaderOptions({ showUnfollowButton }: GroupHeaderOptionsProps) {
    const { tablet, desktop } = useMediaQuery();
    const { t: translate } = useTranslation('groups');

    const wrapperRef = useRef<HTMLDivElement>(null);
    const buttonRef = useRef<HTMLButtonElement>(null);

    const [showSettings, setShowSettings] = useState(false);

    function handleShowSettingsToggle() {
        setShowSettings((show) => !show);
    }

    function handleCloseSettings() {
        setShowSettings(false);
    }

    const popoverMarkup =
        showSettings && tablet ? (
            <Popover alignRight={!desktop} closeExclusions={[buttonRef.current]} onClose={handleCloseSettings}>
                <Settings onClose={handleCloseSettings} showUnfollowButton={showUnfollowButton} />
            </Popover>
        ) : null;

    const drawerMarkup =
        showSettings && !tablet ? (
            <Drawer onClose={handleCloseSettings}>
                <Drawer.Header onClose={handleCloseSettings} />

                <Drawer.Main>
                    <Drawer.Main.Section>
                        <Settings onClose={handleCloseSettings} showUnfollowButton={showUnfollowButton} />
                    </Drawer.Main.Section>
                </Drawer.Main>

                {/*
                    TODO: The "footer actions" within <Settings />
                    should utilize <Drawer.Footer /> but the action
                    APIs don't quite line up yet.
                */}
            </Drawer>
        ) : null;

    return (
        <StyledGroupHeaderOptions ref={wrapperRef}>
            <OptionsButton
                ref={buttonRef}
                variant="solid"
                color="translucent"
                aria-label={translate(showSettings ? 'pods_settings_close_a11y' : 'pods_settings_open_a11y')}
                onClick={handleShowSettingsToggle}
            >
                <ControlsIcon />
            </OptionsButton>

            <AnimatePresence>
                {popoverMarkup}
                {drawerMarkup}
            </AnimatePresence>
        </StyledGroupHeaderOptions>
    );
}
